export default __webpack_public_path__ + "static/media/4.742dc253.JPG";